import { FormattedMessage } from 'react-intl';
import { Alert, AlertTitle, Stack } from '@rossum/ui/material';
import { ValidationError } from '../hooks';

type SchemaErrorsProps = {
  errors: ValidationError[];
};

export const SchemaErrors = ({ errors }: SchemaErrorsProps) => (
  <Alert
    severity="error"
    sx={{
      maxWidth: 600,
      maxHeight: 200,
      overflow: 'auto',
    }}
  >
    <AlertTitle>
      <FormattedMessage
        id="containers.queueSchema.components.editor.errors"
        values={{ count: errors.length }}
      />
    </AlertTitle>
    <Stack component="ul" sx={{ m: 0, pl: 2 }} spacing={0.5}>
      {errors.map(({ key, message }) => (
        <li key={`${key}-${message}`}>
          <strong>{key}: </strong>
          {message}
        </li>
      ))}
    </Stack>
  </Alert>
);
